import { render, staticRenderFns } from "./addCustom.vue?vue&type=template&id=0aba9b41"
import script from "./addCustom.vue?vue&type=script&lang=js"
export * from "./addCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports